import { render, staticRenderFns } from "./AlertasView.vue?vue&type=template&id=51c23556&"
import script from "./AlertasView.vue?vue&type=script&lang=js&"
export * from "./AlertasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports